import React, { useEffect } from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import keyboardjs from 'keyboardjs';
import Zoom from './zoom';

const Toolbar = ({ flipbookRef, containerRef, pdfDetails, viewerStates }) => {
  // Keyboard navigation (left/right)
  useEffect(() => {
    const handleRight = () => flipbookRef.current?.pageFlip()?.flipNext();
    const handleLeft = () => flipbookRef.current?.pageFlip()?.flipPrev();
    keyboardjs.bind('right', null, handleRight);
    keyboardjs.bind('left', null, handleLeft);
    return () => { keyboardjs.unbind('right', null, handleRight); keyboardjs.unbind('left', null, handleLeft); };
  }, [flipbookRef]);

  // Small white island toolbar centered at bottom
  const islandStyle = {
    position: 'absolute',
    bottom: 10,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 60,
  };

  const innerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '2px 6px',
    pointerEvents: 'auto'
  };

  const current = (viewerStates?.currentPageIndex != null) ? (viewerStates.currentPageIndex + 1) : '-';
  const total = pdfDetails?.totalPages ?? '-';

  return (
    <div style={islandStyle} className="toolbar-island">
      <div style={innerStyle}>
        <Button onClick={() => flipbookRef.current?.pageFlip()?.flipPrev()} disabled={viewerStates.currentPageIndex === 0} className="toolbar-btn">
          <ChevronLeft />
        </Button>

        <div className="page-count" aria-hidden>
          {`${current}/${total}`}
        </div>

        <Button onClick={() => flipbookRef.current?.pageFlip()?.flipNext()} disabled={viewerStates.currentPageIndex >= (pdfDetails?.totalPages - 1)} className="toolbar-btn">
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
};

export default Toolbar;
